import styled from 'styled-components'

import { Wrapper as _Wrapper } from '../../styled'

export const Wrapper = styled(_Wrapper)<{ headerHeight?: number }>`
  position: relative;
  height: ${({ headerHeight }) => headerHeight && `calc(100% - ${headerHeight}px - 150px)`} !important;
  padding-top: 40px;
`
